module.exports = __webpack_public_path__ + "img/8.2206d1ae.jpg";